import { AdsCampaignMarketingStrategy } from '@/interface/campaign';
import { useTranslation } from 'react-i18next';

interface Props {
  campaignData: any;
  className?: string;
}

const CampaignMarketingStrategyTag: React.FC<Props> = ({
  campaignData,
  className
}) => {
  const { t } = useTranslation();
  const marketingStrategy = campaignData?.marketingStrategy;

  if (marketingStrategy === AdsCampaignMarketingStrategy.AFFILIATES_MARKETING) {
    return (
      <div
        className={`px-2.5 py-0.5 bg-[#00acff] text-white rounded-lg inline-flex flex-col justify-center items-center gap-2.5 ${className}`}
      >
        <div className="inline-flex justify-center items-center gap-2.5">
          <div className="justify-start text-xs font-medium font-['Inter']">
            {t('campaign.marketing_strategy.affiliate_program', {
              defaultValue: 'Affiliate program'
            })}
          </div>
        </div>
      </div>
    );
  }

  if (marketingStrategy === AdsCampaignMarketingStrategy.INFLUENCER_MARKETING) {
    return (
      <div
        data-state="Secondary"
        className={`px-2.5 py-0.5 bg-[#5a31f0] text-white rounded-lg inline-flex flex-col justify-center items-center gap-2.5 ${className}`}
      >
        <div className="inline-flex justify-center items-center gap-2.5">
          <div className="justify-start text-xs font-medium font-['Inter']">
            {t('campaign.marketing_strategy.paid_sponsorship', {
              defaultValue: 'Paid sponsorship'
            })}
          </div>
        </div>
      </div>
    );
  }

  return marketingStrategy ? (
    <div
      data-state="Secondary"
      className="px-2.5 py-0.5 bg-[#ff8b07] rounded-lg inline-flex flex-col justify-center items-center gap-2.5"
    >
      <div className="inline-flex justify-center items-center gap-2.5">
        <div className="justify-start text-white text-xs font-medium font-['Inter']">
          {marketingStrategy
            ?.split('_')
            .map((word: string, index: number) =>
              index === 0
                ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                : word.toLowerCase()
            )
            .join(' ')}
        </div>
      </div>
    </div>
  ) : null;
};

export default CampaignMarketingStrategyTag;
